export const msalConfig = {
  auth: {
    clientId: process.env.VUE_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.VUE_APP_AZURE_TENANT_ID}`,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "localStorage",
  },
};

export const loginScopes = [
  process.env.VUE_APP_AZURE_API_SCOPE_ID
];
